<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  items: {
    type: Array,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);

const { t } = useI18n();

const onClick = (item, index) => {
  emit('click', item, index);
};
</script>

<template>
  <div class="flex flex-col items-start w-full gap-2">
    <div class="settings-header">
      <nav
        :aria-label="t('BREADCRUMB.ARIA_LABEL')"
        class="flex items-center min-w-0"
      >
        <ol class="flex items-center mb-0 min-w-0 flex-wrap">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="flex items-center"
          >
            <span
              v-if="index > 0"
              class="flex-shrink-0 mx-2 text-3xl text-n-slate-10 text-shadow-xl select-none"
            >
              /
            </span>

            <button
              v-if="index !== items.length - 1"
              class="inline-flex items-center min-w-0 gap-2 p-0 text-3xl font-semibold tracking-tight text-shadow-xl transition-colors border-0 text-n-slate-10 hover:text-n-slate-12 outline-transparent"
              @click="onClick(item, index)"
            >
              <span class="min-w-0 truncate">{{ item.label }}</span>
            </button>

            <span
              v-else
              class="text-3xl font-semibold tracking-tight text-n-slate-12 text-shadow-xl min-w-0"
            >
              {{ item.label }}
            </span>
          </li>
        </ol>
      </nav>
      <div class="flex items-center gap-2 flex-shrink-0">
        <slot />
      </div>
    </div>
    <p v-if="description" class="text-sm text-n-slate-11 mb-0">
      {{ description }}
    </p>
  </div>
</template>
